import { Image, Text, Box, Flex, Button } from "@chakra-ui/react";
import Logo from "@/assets/logo.png";
import LogsIcon from "@/assets/logs.png";
import * as animationData from "@/assets/loading.json";
import Lottie from "lottie-react";

const LoadingPage = () => {
  return (
    <Flex
      sx={{
        background: "#FFFCF9",
        width: "100%",
        height: "100%",
        padding: "20px",
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 1000,
      }}
      flexDir={"column"}
    >
      <Flex
        sx={{
          flex: 1,
        }}
        align={"center"}
        justify={"center"}
        flexDir={"column"}
      >
        <Image
          src={Logo}
          sx={{
            width: "60px",
            height: "60px",
          }}
        ></Image>
        <Image
          src={LogsIcon}
          sx={{
            width: "74px",
            marginTop: "10px",
          }}
        ></Image>
        <Text
          sx={{
            color: "#333",
            textAlign: "center",
            fontSize: "14px",
            fontStyle: "italic",
            fontFamily: "DIN DIN-Black",
          }}
        >
          For Business
        </Text>
        <Text
          sx={{
            color: "#333",
            textAlign: "center",
            fontSize: "20px",
            fontWeight: 500,
          }}
        >
          Frictionless Money Movement{" "}
        </Text>
        <Lottie
          animationData={animationData}
          loop={true}
          style={{
            width: "40px",
            height: "40px",
            marginTop: "12px",
          }}
        />
      </Flex>
    </Flex>
  );
};

export default LoadingPage;
